// extracted by mini-css-extract-plugin
export var content = "FormSelect-module--content--e1284";
export var icon = "FormSelect-module--icon--29f7f";
export var item = "FormSelect-module--item--3e3cd";
export var itemIndicator = "FormSelect-module--itemIndicator--0a56d";
export var trigger = "FormSelect-module--trigger--30a2d";
export var viewport = "FormSelect-module--viewport--60dca";